"use client";
import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import useHandleNotificationClick from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/useHandleNotificationClick";

const JackpotWinNotification: FC<NotificationViewProps> = ({
  notification,
  onClose,
  context,
}) => {
  const { handleCloseNotificationClick, handleNotificationClick } =
    useHandleNotificationClick({
      context,
      notification: notification.data,
      onClose,
    });

  return (
    <Content
      testId={`${notification.type}-notification`}
      onClose={handleCloseNotificationClick}
    >
      <h4 className="text-lg/6 font-medium text-black mt-7">
        <Translation
          id="jackpot.win_notification.title"
          translations={context.translations}
        />
      </h4>
      <Translation
        id="jackpot.win_notification"
        translations={context.translations}
        values={{
          amount: notification.data.amount,
          user: notification.data.user,
        }}
      />
      <div className="grid grid-cols-2 gap-2">
        <Button
          onClick={handleCloseNotificationClick}
          variant="outline"
          className="text-black bg-white"
        >
          <Translation id="general.close" translations={context.translations} />
        </Button>
        <Button onClick={handleNotificationClick}>
          <Translation
            id={
              notification.data.isOptedIn
                ? "jackpot.see_jackpots"
                : "jackpot.opt_in_now"
            }
            translations={context.translations}
          />
        </Button>
      </div>
    </Content>
  );
};

export default JackpotWinNotification;
